import { BaseException, BaseExceptionContext } from './base.exception';

interface ForbiddenExceptionContext extends BaseExceptionContext {}

export class ForbiddenException extends BaseException {
  constructor(entity: string, context: ForbiddenExceptionContext) {
    super(`Forbidden access to ${entity}`, context);
  }
}
